import { combineReducers } from 'redux';
import translation from './translation';

export default combineReducers({
    translation,
})